import { NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import type { ConfirmationOptions, DialogResult } from '../models';
import { ConfirmationDialog } from './confirmation-dialog';

@Component({
    selector: 'qpx-confirmation-dialog-host',
    imports: [NgTemplateOutlet, ConfirmationDialog],
    templateUrl: './confirmation-dialog-host.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogHost {
    //#region Dependency injection
    private readonly dialogRef =
        inject<MatDialogRef<ConfirmationDialogHost, DialogResult>>(
            MatDialogRef
        );
    //#endregion

    //#region Inputs
    public readonly data = input<ConfirmationOptions>({});
    //#endregion

    //#region Template methods
    protected onConfirm(): void {
        this.dialogRef.close(true);
    }

    protected onCancel(): void {
        this.dialogRef.close(false);
    }
    //#endregion
}
